export const convertUnixTimestampToPostgresTimestamp = (unixTimestamp?: number | null): string => {
  if (unixTimestamp === undefined || unixTimestamp === null) {
    return '';
  }
  // Create a new Date object from the Unix timestamp (converted to milliseconds)
  const date = new Date(unixTimestamp * 1000);

  // Convert the Date object to an ISO 8601 string format
  // This results in a string format that PostgreSQL understands for its timestamp with time zone type
  return date.toISOString();
};

export const formatTimestamp = (timestamp: string): string => {
  if (timestamp == null || timestamp === '') return '';
  const date = new Date(timestamp);
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short',
  };

  return new Intl.DateTimeFormat('en-US', options).format(date);
};

export const formatDate = (timestamp: string, opts?: Intl.DateTimeFormatOptions): string => {
  if (timestamp == null || timestamp === '') return '';

  let date;
  try {
    // Check if the timestamp already has timezone info (ends with Z or +/-XX:XX)
    if (/Z$|[+-]\d{2}:\d{2}$/.test(timestamp)) {
      date = new Date(timestamp);
    } else {
      // For timestamps without timezone info, assume UTC
      date = new Date(timestamp + 'Z');
    }

    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: opts?.hour ?? undefined,
      minute: opts?.minute ?? undefined,
      second: opts?.second ?? undefined,
      timeZone: 'UTC', // Ensure UTC timezone
      ...(opts ?? {}),
    };

    return new Intl.DateTimeFormat('en-US', options).format(date);
  } catch (e) {
    console.warn(`Invalid date format: ${timestamp}`);
    return timestamp; // Return the original string if parsing fails
  }
};

/**
 return 
 0 = Sunday
 1 = Monday
 2 = Tuesday
 3 = Wednesday
 4 = Thursday
 5 = Friday
 6 = Saturday
 */
export const getDayOfWeek = (dayOfWeekInt: number): string => {
  return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][
    dayOfWeekInt
  ];
};
